export default {
  home: 'NEXT',
  notifications: 'Notifications',
  schedule: 'Schedule',
  openShifts: 'NEXT Shifts',
  chat: 'Chat',
  myShifts: 'My Shifts',
  announcements: 'News',
  messages: 'Messages',
  dm: 'Direct Messages',
  groups: 'Groups',
  marked: 'Marked',
  markedMessages: 'Marked Messages',
  sentMessages: 'Sent Messages',
  sent: 'Sent',
  tools: 'Tools',
  verify: 'Verify',
  verifyPhone: 'Verify Phone Number',
  activate: 'Activate',
  settings: 'Settings',
  pendingApproval: 'Pending Approval',
  markAllRead: 'Mark All As Read',
  shift: 'Shift',
  startDate: 'Start Date',
  endDate: 'End Date',
  holidays: 'Holidays',
  timeOff: 'Time Off',
  timeOffRequest: 'Time Off Request',
  timeOffRequests: {
    zero: 'No Time Off Requests',
    one: '1 Time Off Request',
    other: '{{count}} Time Off Requests',
  },
  noNewTimeOffRequests: 'No New Time Off Requests',
  requestTimeOff: 'Request Time Off',
  editTimeOff: 'Edit Time Off Request',
  addReasonForTimeOff: 'Add Reason for Time Off (Required)',
  approvedTimeOff: 'Approved Time Off',
  rejectedTimeOff: 'Rejected Time Off',
  requestedTimeOff: 'Requested Time Off',
  timeOffRequestList: 'Time Off Requests',
  editTimeOffRequest: 'Edit Time Off Request',
  updateRequest: 'Update Request',
  sendRequest: 'Send Request',
  allDay: 'All Day',
  days: {
    // zero: 'No Time Off Requests',
    one: '1 Day',
    other: '{{count}} Days',
  },
  day: 'Day',
  week: 'Week',
  working: 'Working',
  approvedBy: 'Approved By',
  user: 'User',
  account: 'Account',
  selectValue: 'Select Value',
  calendars: 'Calendars',
  editShift: 'Edit Shift',
  anyPosition: 'Any Position',
  helper: 'Crew',
  manager: 'Manager',
  observer: 'Observer',
  chooseRole: 'Choose Role',
  unreadNotifications: 'Unread notifications',
  openShiftsAvailable: 'NEXT Shifts available',
  done: 'Done',
  next: 'Next',
  cancel: 'Cancel',
  create: 'Create',
  stores: 'Stores',
  store: 'Store',
  helperSchedule: 'My Shifts',
  storeSchedule: 'Store Schedule',
  chatNotAvailable: 'Chat not available.',
  signingOut: 'Signing out...',
  welcomeTextList: [
    'Hi {FIRST_NAME}',
    'Hello {FIRST_NAME}',
    'Welcome {FIRST_NAME}',
    'Cheers {FIRST_NAME}',
    'Good day, {FIRST_NAME}',
    `Have a great {DAY_NAME}, {FIRST_NAME}`,
    `Happy {DAY_NAME}, {FIRST_NAME}`,
  ],
  seeMore: `See %d more`,
  andMore: '& {{count}} more',
  noNew: `No new`,
  storeOpenShifts: 'NEXT Shifts',
  loggedInAs: 'Logged In as',
  editMyProfile: 'Edit My Profile',
  editUsernameAndPhoto: 'Edit Name and Photo',
  uploadPhoto: 'Tap to upload photo',
  avatarDesc: 'Add a photo so managers and co-workers recognize you',
  signOut: 'Sign Out',
  privacyPolicy: 'Privacy Policy',
  termsOfUse: 'Terms and Conditions',
  crewList: 'My Crew',
  enter: 'Enter',
  selected: 'Selected',
  from: 'From',
  to: 'To',
  profile: 'Profile',
  addMobileNumber: 'Add Mobile Number',
  addMobileNumberErrorTitle: 'Could not add Mobile Number',
  enterMobileNumberHere: 'Enter mobile number here',
  addMobileNumberText:
    'Add a mobile number for {USER_NAME}. Make sure it is a mobile phone number and not a landline.',
  seeAll: 'See All >',
  confirmShiftAction: 'Confirmation',
  requestHelp: ' Request Help',
  confirmEdit: 'Confirm Edit',
  addShift: 'Add Shift',
  noOpenShifts: 'No NEXT Shifts available.',
  confirmMarkAll: 'Mark all as read?',
  confirmSendAttachment: 'Send File ?',
  noShifts: 'No shifts.',
  makeChanges: 'Make Changes',
  groupMessages: 'Group Messages',
  directMessages: 'Direct Messages',
  noDirectMessages: 'No direct messages',
  deleteOwn: 'Delete',
  deleteOthers: 'Delete',
  showReadersOwn: 'Read by...',
  showReadersOthers: 'Read by...',
  pinMessage: 'Pin',
  unpinMessage: 'Unpin',
  mark: 'Mark',
  unmark: 'Unmark',
  mention: 'Mention',
  mentions: 'Mentions',
  makeGroupAdmin: 'Make Group Admin',
  removeGroupAdmin: 'Dismiss as Admin',
  admin: 'Admin',
  directMessagePrompt:
    'Press and hold on any message to reply with a direct message.',
  updateMessage:
    'A new update is available. The app will be updated the next time you restart it.',
  updateAvailable: 'Update Available',
  newAppVersion:
    'A newer version of this app is available. Tap here to update.',
  addMembers: 'Add Members',
  newGroup: 'New Group',
  createGroup: 'Create Group',
  saving: 'Saving...',
  save: 'Save',
  members: 'Members',
  details: 'Details',
  you: 'You',
  name: 'Name',
  description: 'Description',
  descriptionPlaceholder: 'Add group description',
  deleteGroup: 'Delete Group',
  deleteGroupConfirmation: 'Delete group?',
  leaveGroup: 'Leave Group',
  leaveGroupConfirmation: 'Leave group?',
  leaveGroupConfirmationDescription:
    'Are you sure you want to leave this group?',
  leaveGroupConfirmationAdminDescription:
    'You are one of the admins for this group. Are you sure you want to leave it?',
  cannotLeaveGroup: 'Cannot leave group',
  deleting: 'Deleting...',
  add: 'Add',
  removeMember: 'Remove Member',
  removeMemberConfirm: 'Remove member?',
  sendDirectMessage: 'Send Message',
  send: 'Send',
  sendVerificationCode: 'Send Verification Code',
  copyMessage: 'Copy',
  chooseRecipient: 'Choose Recipient',
  loading: 'Loading...',
  loadingMore: 'Loading more...',
  readBy: 'Read By',
  readBySummary: 'Read by {{current}} out of {{total}}',
  noReaders: 'No readers',
  noResults: 'No Results.',
  noNotifications: 'No notifications.',
  noCrew: 'No crew.',
  createShiftErrorTitle: 'Could not create shift',
  editShiftErrorTitle: 'Could not edit shift',
  editTimeOffErrorTitle: 'Could not edit time off request',
  cancelShiftErrorTitle: 'Could not cancel shift',
  swapShiftErrorTitle: 'Could not swap shift',
  assignShiftErrorTitle: 'Could not assign shift',
  shiftActionErrorTitle: 'Could not perform shift action',
  callOutCoverActionErrorTitle: 'Could not assign call out cover',
  callOutDetails: 'CALL OUT DETAILS',
  coverCallOut: 'COVER CALL OUT',
  changeAmount: 'Change Amount',
  incentives: 'Incentives',
  changeIncentiveAmount: 'Change incentive amount for this NEXT Shift.',
  currentIncentiveAmount: 'CURRENT INCENTIVE AMOUNT',
  increaseBonus: 'Increase amount by pressing "+".',
  decreaseBonus: 'Decrease amount by pressing "-".',
  incrementBonusError:
    'Maximum Critical Bonus Amount for this shift is ${{maxAmount}}',
  decrementBonusError:
    'Minimum Critical Bonus Amount for this shift is ${{minAmount}}',
  changeIncentive: 'CHANGE INCENTIVE AMOUNT TO',
  confirmChangedAmount: 'Confirm Changed Amount',
  error: 'Error',
  date: 'Date',
  startTime: 'Start Time',
  endTime: 'End Time',
  shiftPositionPrompt: 'What help do you need?',
  shiftReasonPrompt: 'Why?',
  shiftDateTimePrompt: 'When?',
  position: 'Position',
  reason: 'Reason',
  pendingMessage: `Welcome to NEXT!

We need some more infomation to help add you to your home store.

To complete verification please send us your name, mobile phone number, and store phone number to this email address:

onboarding@nextforce.us`,
  helpdesk: 'Helpdesk',
  noteToManager: 'Note to manager',
  requestNote: 'Request Note',
  noShiftsNoSwap: 'No shifts so swap is not possible',
  selectDifferentCrew: 'Select a Different Crew Member',
  crewAvailable: 'CREW AVAILABLE TO PICK UP SHIFT',
  whoIsCanceling: 'WHO IS CANCELING THIS SHIFT ?',
  cancellation: 'Cancellation',
  crewCanceled: 'This will count as crew member canceled in their work history',
  crewCancelReason:
    '[REQUIRED] Enter the reason the crew member is canceling. Note, this is only shared with your co-managers and NOT visible to the crew member',
  onboard: 'Finish Onboarding',
  welcomeToNext: 'Welcome to NEXT',
  enterYourPhoneNumberForVerification:
    'Enter your mobile number below, pick text or phone call, and then press the Send Verification Code button.',
  verificationSMSFees:
    'We will send a verification code by texting or by calling you at the number entered above. SMS fees may apply.',
  whatsYourPhoneNumber: `What's your mobile number?`,
  mobileNumber: 'Enter Your Mobile Number',
  qrCodeDescription:
    'Alternatively, Sign In to NEXT Web by Scanning the QR from the mobile app. Go to Tools -> Scan Login QR Code.',
  signUpAgreement: 'By signing up, you agree to the',
  termsOfService: 'Terms of Service',
  verifying: 'Verifying...',
  activating: 'Activating...',
  onboarding: 'Onboarding...',
  enterTheVerificationCode:
    'Enter the verification code you received on the phone number:',
  whatsTheVerificationCode: `What's the verification code?`,
  verificationCode: 'Verification code',
  continue: 'Continue',
  signIn: 'Sign In',
  hello: 'Hello!',
  onboardMessage: `Complete the onboarding process by entering the information requested below.`,
  enterFirstAndLastName: 'Your first and last name',
  firstAndLastName: 'First and last name',
  enterMonthDateOfBirth: 'Month and date of birth',
  enterStorePhoneNumber: "Your Store's phone number",
  storePhoneNumber: 'Store phone number',
  enterYourPhoneNumber: 'Enter Mobile number again',
  phoneNumber: 'Mobile number',
  finish: 'Finish',
  onboardingHelperMessage:
    'If you are having difficulties onboarding please email us at',
  invalidPhoneNumber: 'Invalid phone number',
  invalidStorePhoneNumber: 'Invalid store phone number',
  timeOffRequestExplanation:
    'When you are unavailable, request days off from your weekly schedule through the NEXT app.<br/><ul><li>If you are requesting <i>paid</i> time off, the request must be made using your HR/payroll app.</li><li>Requests will be reviewed and accommodated whenever possible, but are not guaranteed.</li></ul>',
  timeOffRequestAttestation:
    "My request complies with my company's policies for time off.",
  cancelRequest: 'Cancel Request',
  submitRequest: 'Submit Request',
  shiftBonus: 'Shift Bonus',
  bonus: 'Bonus',
  seeNextShifts: 'See NEXT Shifts',
  seeNextShiftsOn: {
    one: 'See 1 NEXT Shift on %{date}',
    other: 'See %{count} NEXT Shifts on %{date}',
  },
  seeNextShiftsMatching: {
    one: 'See 1 NEXT Shift matching',
    other: 'See %{count} NEXT Shifts matching',
  },
  seeNextShiftsWithIncentives: {
    one: 'See 1 NEXT Shift with incentives',
    other: 'See %{count} NEXT Shifts with incentives',
  },
  noScheduledShifts: 'No Scheduled Shifts.',
  pickUpNextShifts: 'Pick up NEXT Shifts?',
  userList: 'User List',
  workedShift: 'Worked Shift',
  didNotWorkShift: 'Time Punch Not Available Yet',
  support: 'Support',
  chooseStore: 'Choose a store...',
  back: 'Back',
  summaryNotAvailable: 'Summary not available',
  see: 'See',
  shiftsWithAlerts: 'Shifts with alerts',
  customFilter: 'Filter...',
  filter: 'Filter',
  filtered: 'Filtered',
  apply: 'Apply',
  reset: 'Reset',
  positions: 'Positions',
  criticalShifts: 'Critical shifts',
  shiftsWithMinor: 'Shifts with minor',
  shiftsWithInterest: 'Shifts with interest',
  nextShifts: 'NEXT Shifts',
  nextShiftsMatchingPreset: 'NEXT Shifts matching Preset',
  nextShiftsMatching: 'NEXT Shifts matching',
  nextShiftsWithIncentives: 'NEXT Shifts with incentives',
  allNextShifts: 'All NEXT Shifts',
  nextShiftsWithIncentivesMoreThan10Dollars:
    'NEXT Shifts with incentives $10 or more',
  nextShiftsWithIncentivesMoreThan20Dollars:
    'NEXT Shifts with incentives $20 or more',
  nextShiftsWithoutIncentives: 'NEXT Shifts without incentives',
  breakfast: 'Breakfast (Start time 7am - 9am)',
  lunch: 'Lunch (Start time 11am - 2pm)',
  dinner: 'Dinner (Start time 5pm - 7pm)',
  shiftsWithBonus: 'Shifts with bonus',
  crewMembers: 'Crew Members',
  all: 'All',
  none: 'None',
  allShifts: 'All Shifts',
  member: 'Member',
  alerts: 'Alerts',
  critical: 'Critical',
  minor: 'Minor',
  interest: 'Interest',
  rootedDeviceNotSupported: 'Rooted Devices Not Supported',
  thisWeek: 'This Week',
  lastWeek: 'Last Week',
  trend: 'Trend',
  shifts: 'Shifts',
  hrs: 'Hrs',
  totals: 'Totals',
  crewScheduled: 'Crew Scheduled',
  crewOnNext: 'Crew On NEXT',
  shiftsScheduled: 'Shifts Scheduled',
  laborHours: 'Labor Hrs',
  otHours: 'OT Hrs',
  callOuts: 'Call Outs',
  seeWeeklySummary: 'See Weekly Summary',
  gotIt: 'GOT IT',
  myGroups: 'My Groups',
  storeGroups: 'Store Groups',
  showWeeklySummary: 'Show Weekly Summary',
  closeWeeklySummary: 'Close Weekly Summary',
  notFound: 'Not Found',
  searchMessages: 'Search Messages',
  searchShowingResultsFromDays: 'Showing results from last {{count}} days',
  loadEarlierMessages: 'Load Earlier Messages',
  connectionError: 'Not connected to network',
  noInternetScheduleScreenMessage:
    'You can view your current schedule, but it will not be updated until you reconnect.',
  newMessage: 'New Message',
  message: 'Message',
  myOpenShifts: 'My NEXT Shifts',
  showSummaryTiles: 'Show event summaries',
  savedFilters: 'SAVED FILTERS',
  saveFilter: 'Save Filter',
  saveFilterText: 'Select a slot to save filter in',
  howMany: 'How Many',
  multipleShifts: {
    one: 'Add 1 NEXT Shift %{positionName}',
    other: 'Add %{count} NEXT Shifts %{positionName}',
  },
  multipleNotifications: 'Multiple Notifications',
  multipleNotificationsDesc:
    'You have %{count} new notifications. Please check your NEXT App',
  textMe: 'Text Me',
  callMe: 'Call Me',
  splitShiftTitle: 'Split NEXT Shift?',
  splitShiftMessage: `Shorter NEXT Shifts have a better chance of getting filled. This NEXT Shift can be split into multiple short consecutive NEXT Shifts.

  Would you like to split the shift?`,
  addAndAssign: 'Add & Assign',
  assignShift: 'Assign this Shift to Crew Member',
  assignToThisCrew: 'Assign Shift to this Crew Member',
  assignShiftPositionPrompt: 'Add Shift & Assign to Crew Member',
  refreshCounter: 'Refreshes in %{count} seconds.',
  imageLibraryPermissionDeniedTitle:
    'You have not given permission to access your photos and videos.',
  imageLibraryPermissionDeniedBody:
    'Please go to Privacy -> Photos in Settings app',
  cameraPermissionDeniedTitle:
    'You have not given permission to access camera.',
  cameraPermissionDeniedBody: 'Please go to Privacy -> Camera in Settings app',
  syncToCalendar: 'Sync to phone calendar',
  calendarPermissionDeniedTitle: 'Manage settings',
  calendarPermissionDeniedBody:
    'Go to app settings and allow calendar permission',
  addShiftsToCalendar: 'Add scheduled shifts to your phone calendar?',
  yes: 'Yes',
  no: 'No',
  notNow: 'Not Now',
  calendarSyncAlert:
    'You can enable the calendar sync setting by going to Settings screen',
  devTools: 'Dev Tools',
  downloadNextMessage:
    'Our store uses NEXT for schedules and messaging. Download NEXT for Managers and Crew by clicking bit.ly/NEXT-Android OR bit.ly/NEXT-iOS',
  version: 'Version',
  update: 'Update',
  sharingIsOffError: 'Cannot assign to crew at selected store. Sharing is off.',
  storeTooFarError:
    'Cannot assign to crew at selected store. Store is too far away.',
  test: 'Test',
  apiEndpoint: 'API Endpoint',
  shareNext: 'Share NEXT',
  scanQr: 'Scan QR Code',
  scanQrDescription: 'Scan QR Code to Login to NEXT Web.',
  shareNextWithCoworkers: 'Share NEXT with your coworkers',
  submit: 'Submit',
  crewRatingTitle: 'How was {{name}} shift?',
  crewRatingDescription:
    '{{name}} completed this shift on {{date}} at {{time}}',
  storeRatingTitle: 'How was your shift at {{store}}',
  storeRatingDescription: 'You completed this shift on {{date}} at {{time}}',
  badShiftReview: 'I HAD A BAD SHIFT',
  okayShiftReview: 'IT WAS OKAY',
  goodShiftReview: 'IT WAS GOOD',
  greatShiftReview: 'IT WAS GREAT!',
  sharingErrorMessage: 'Your device does not allow sharing',
  sharingErrorName: 'Sharing Error',
  sharingNotAvailable: 'Sharing not available',
  rateStore: 'Rate Store',
  rateShifts: 'Rate recent NEXT Shifts',
  rateShift: 'Rate Shift',
  noShiftsToRate: 'No shifts to rate',
  markAllNotificationsReadError: 'Error marking all notifications as read',
  managersAndAbove: 'Managers and Above',
  managementTeam: 'Management Team',
  teamMember: 'Team Member',
  createEvent: 'Create Event',
  editEvent: 'Edit Event',
  addNewEvent: 'Add New Event',
  eventTitle: '*Event Title',
  eventDescription: '*Event description. Max 280 characters',
  addCustomEventErrorTitle: 'Could not create custom event',
  editCustomEventErrorTitle: 'Could not edit custom event',
  editUsernameErrorTitle: 'Error editing username',
  allStoreVisibilityText: {
    zero: 'All',
    one: 'Store',
    other: 'All {{count}} Stores',
  },
  storeSelectedText: {
    one: '1 Store selected',
    other: '{{count}} Stores selected',
  },
  customEvent: 'Events',
  deleteEvent: 'Delete Event',
  deleteEventErrorTitle: 'Could not delete event',
  filtersHelpTitle: 'Help using filters',
  filtersExplanationMessage: `Select just the NEXT Shifts you prefer with filters for stores, position, incentives, and start times. Once you set the filters hit the Apply button to see the matching NEXT Shifts.

Save three different filters by tapping the Save button and then tapping button 1, 2, or 3.

You can then tap the 1, 2, or 3 button and the Apply button to view filtered NEXT Shifts.

Your saved filter selections will display on your homepage My NEXT Shifts tile for your convenience.`,
  choosePhoto: 'Choose Photo',
  uploadPhotoModalText: 'Would you like to upload a profile photo?',
  uploadPhotoAlert:
    'You can upload a profile photo at any time by tapping Account icon on top right of toolbar and then tapping the photo placeholder.',
  uploadPhotoAlertTitle: 'Upload a profile photo',
  removePhotoTitle: 'Remove Profile Photo',
  removePhotoText: 'Are you sure you want to remove your profile photo?',
  readOnly: 'Read Only',
  crew: 'Crew',
  managers: 'Managers',
  reminders: 'Reminders',
  birthdayWorkAnniversaryAndNewHire: 'Hiring, Anniversaries & Birthdays',
  coverRequestMessageTitle:
    'Sharing a message to the company-wide group about why you need your shift covered may motivate coworkers to help out',
  messagePlaceholder: 'Write your message here',
  anytimeMetrics: 'Any-time Crew Metrics',
  metricsCaluculatedOverLastFourWeeks:
    'Metrics calculated over last four weeks',
  NEXTShiftsWorkedOverLastFourWeeks: 'NEXT Shifts worked over last 4 weeks',
  NEXTShiftRating: 'NEXT Shift Rating (number of ratings)',
  notActiveUser: 'Not active user',
  occasionalUser: 'Occasional user',
  regularUser: 'Regular user',
  notActive: 'Not active',
  occasionalInterest: 'Occasional interest',
  regularInterest: 'Regular interest',
  crewMetricsLearnMore:
    'Tap to learn more about the performance metrics for Any-time Crew',
  monthlyProgress: 'My Monthly Progress',
  currentEstimate: 'Current Estimate',
  actual: 'Actual',
  currentMonthTargetMetMessage: 'Good Job! Tracking to Exceed Target',
  currentMonthTargetNotMetMessage: 'Pick up NEXT Shifts',
  priorMonthTargetMetMessage: 'Exceeded Target',
  earningsRate: 'Earnings Rate ${{rate}}',
  priorMonthTargetNotMetMessage: 'Missed Target',
  monthlyProgressExplanationMessage:
    'NEXT helps track your progress towards your monthly earnings target. You can adjust the monthly earnings goal from your Accounts>Edit My Profile screen and by tapping this tile. You can also update the Earnings Rate used to calculate Gross Earnings from the Account>>Edit My Profile screen.',
  hours: 'hours',
  hour: 'hour',
  grossPay: 'Gross earnings',
  monthlyTarget: 'Monthly Target',
  daysToGo: '{{days}} days to go',
  monthlyEarningsDescriptionTitle: 'Adjust Monthly Earnings and Pay Rate',
  visibility: 'Visibility',
  everyone: 'Everyone',
  splitNextShiftFromCancelledShiftTitle: 'NEXT Shift will be split',
  splitNextShiftFromCancelledShiftMessage:
    'Shorter NEXT Shifts have a better chance of getting filled. This NEXT Shift will be split into multiple short consecutive NEXT Shifts.',
  composeMessageDescriptionText:
    'Send the same message to multiple groups and/or individuals by adding names in the To: field',
  callOutCoverageScreenTitle: 'Smart Callout Coverage',
  crossStoreClockInOut: 'cross store clock in/out >',
  uploadProfilePhotoError: 'Error uploading profile photo',
  storePreferences: 'Store Preferences',
  conversationDeleted: 'Conversation deleted',
  conversationDeletedDescription: 'This conversation has been deleted.',
  noMessages: 'No Messages.',
  noPinnedMessages: 'No Pinned Messages.',
  filteredMembers: 'Filtered Members',
  filteredStores: 'Filtered Stores',
  call: 'Call',
  edit: 'Edit',
  remove: 'Remove',
  addRemove: 'Add/Remove',
  search: 'Search',
  addTeamMember: 'Add Team Member',
  editTeamMember: 'Edit Team Member',
  firstName: 'First Name',
  lastName: 'Last Name',
  select: 'Select',
  chooseStores: 'Choose Stores',
  choose: 'Choose',
  enterUserPhoneNumber:
    "Enter the mobile number of the user you want to add to the Management Team, then tap 'Next' to continue.",
  enterMobileNumber: 'Enter the Mobile Number',
  addUserInfoText:
    'Complete the process by entering the information requested below.',
  inviteToNext: 'Invite to NEXT',
  inviteToNextDescription: 'Send an SMS to the user to download the NEXT App',
  atLeastOneStoreRequired: 'At least one store is required.',
  selectedStores: 'Selected Stores',
  deleteUserErrorTitle: 'Could not delete user',
  confirmDeleteUserTitle: 'Delete',
  confirmDeleteUserMessage: 'Are you sure you want to delete this user?',
  confirmDeleteObserverTitle: 'Remove From Management Team',
  confirmDeleteObserverMessage:
    'Are you sure you want to remove this user from the management team?',
  deleteObserverErrorTitle: 'Could not remove user from management team.',
  delete: 'Delete',
  confirmDeleteItem: 'Are you sure you want to delete this item?',
  recentChanges: 'Recent Changes',
  retry: 'Retry',
  showErrors: 'Show errors',
  hideErrors: 'Hide errors',
  localeConfirm: 'Locale has been changed. Switch to new locale ?',
  edited: 'Edited',
  added: 'Added',
  changed: 'Changed',
  removed: 'Removed',
  toTheManagementTeam: 'to the Management Team',
  fromTheManagementTeam: 'from the Management Team',
  loadingAccount: 'Loading account information',
  loadingUser: 'Loading user',
  loadingStores: 'Loading stores',
  loadingNotifications: 'Loading notifications',
  loadingMessages: 'Loading messages',
  loadingHomeScreen: 'Loading home screen',
  loadingData: 'Loading data',
  errorModalTitle:
    'Some features may not work correctly. Press button to reload the app.',
  uploadInProgressDescription:
    'Please do not close the app until upload is complete...',
  sendMessageError: 'Error sending message',
  media: 'Media',
  documents: 'Documents',
  mediaFiles: 'Media Files',
  pinnedMediaFiles: 'Pinned Media Files',
  linkPreviewError: 'Error fetching link preview',
  conversations: 'Conversations',
  allConversations: 'Conversations',
  allStores: 'All Stores',
  guestTeam: 'Guests',
  staffTeam: 'Staff',
  management: 'Management',
  noMembers: 'No Members',
  invalidAuthCode: 'Invalid authorization code',
  qrCodeExpiredRegenerating: 'QR code expired. Regenerating...',
  teamMemberUpdated: 'Team member updated',
  teamMemberUpdatedDescription:
    '{{name}} has been updated in the {{teamName}} Team',
  teamMemberAdded: 'Team member added',
  teamMemberAddedDescription:
    '{{name}} has been added to the {{teamName}} Team',
  teamMemberDeleted: 'Team member deleted',
  teamMemberDeletedDescription:
    '{{name}} has been removed from the {{teamName}} Team',
  teamMemberUpdateErrorTitle: 'Error updating team member',
  teamMemberAddErrorTitle: 'Error adding team member',
  teamMemberDeleteErrorTitle: 'Error deleting team member',
  noToolsAvailable: 'No tools available',
  companyNameJobTitle: 'Company Name / Job Title',
  alreadyAMember: 'Already a member.',
  userBeingAddedTitle: 'User is being added',
  userBeingAddedDescription:
    'User is being being added to the Management Team. Please wait for the process to complete.',
  dropFilesHere: 'Drop files here',
  deleteMessage: 'Delete Message',
  deleteMessageConfirmation: 'Delete message?',
  reasonForTimeOff: 'Reason for Time Off',
  noRecentChanges: 'No recent changes',
  noStoresFound: 'No stores found',
  noMembersFound: 'No members found',
  guest: 'Guest',
  staff: 'Staff',
  blockRtoCustomEventText: 'Do not allow time off requests during this event',
  editHolidayEventTitle: 'Edit Holiday Event',
  editHolidayEventErrorTitle: 'Could not edit holiday event',
  editHolidayEventHeading: 'Disallow Time Off Request for this Holiday',
  editHolidayEventDescription:
    'Time off requests on this holiday will be not be allowed for selected stores',
  accessDenied: 'Access Denied',
  navigationAccessDeniedMessage:
    'You do not have permission to access this screen.',
  recentFiles: 'Recent Files',
  chatGroupMedia: 'Chat Group Media',
  images: 'Images',
  videos: 'Videos',
  pdfs: 'PDFs',
  otherFiles: 'Other Files',
  fileFolderSearch: 'Search Files & Folders',
  filesGroupDescription:
    'A group that is used to exclusively share files and folders. Only admins can create and manage folders and files. Members can view files. No messages are allowed in this group.',
  pinned: 'Pinned',
  attached: 'Attached',
  editFile: 'Edit File',
  editFolder: 'Edit Folder',
  noFiles: 'No Files',
  filesGroup: 'Files Group',
  externalUrl: 'External URL',

  createdBy: 'Created By',
  uploadedBy: 'Uploaded By',
  noFilesOrFoldersFound: 'No files or folders found',
  loadingRepositoryText:
    'Updating Repository Directory. Might take a few mins.',
  addFolder: 'Add Folder',
  pasteHere: 'Paste here',
  today: 'Today',
  lastMonth: 'Last Month',
  thisMonth: 'This Month',
  type: 'Type',
  externalFile: 'External File',
  unknown: 'Unknown',
  openFile: 'Open File',
  chatGroupMediaFiles: 'Chat Group Media Files',
  viewAll: 'View All',
  noFilesFound: 'No Files Found',
  sortBy: 'Sort By',
  viewAs: 'View As',
  default: 'Default',
  nameAsc: 'Name',
  dateAsc: 'Oldest',
  dateDesc: 'Newest',
  sizeDesc: 'Largest',
  externalFileInfo:
    'An external file is a link to a third-party file not stored on NEXT.',
  upload: 'Upload',
  fileSize: 'File Size',
  path: 'Path',
  fileViewer: 'File Viewer',
  fileFolderActionErrorTitle: 'Could not perform resource action',
  fileFolderActionCrossGroupErrorDescription:
    ' Cannot move/copy resources between different chat groups.',
  loadingRecipientsText:
    'Loading might take a few minutes as user directory is getting processed for the first time.',
  pendingTimeOffRequestsOverlapWithBlackoutDatesText:
    'Request overlaps with recently added blackout date(s).',
  loadingChat: 'Loading Chat',
  loadingChatText:
    'Processing messages for the first time. This might take a while.',
  loadingChatProgress: 'Processed {{current}} of {{total}} messages',
  messageDeletedBy: 'Message deleted by {{name}}',
  youDeletedThisMessage: 'You deleted this message',
  downloadingChat: 'Downloading chat messages',
  loadingMemberProgress: 'Processed {{current}} of {{total}} members',
  loadingMembers: 'Loading Members',
  downloadingMembers: 'Downloading members',
  copyHere: 'Copy here',
  moveHere: 'Move here',
  addLink: 'Add Link',
  title: 'Title',
  selectFile: 'Select File',
  selectPhotoVideo: 'Select Photo/Video',
  webDocument: 'Web Document',
  files: 'Files',
  folders: 'Folders',
  grid: 'Grid',
  list: 'List',
  timeline: 'Timeline',
  shared: 'Shared',
  openWebLink: 'Open Web Link',
  summary: 'Summary',
  disallowRto: 'Disallow Time Off Request',
  madeEditText: {
    one: '{{name}} made an edit',
    other: '{{name}} made edits',
  },
  eventCreatedBy: 'Event created by {{name}} on {{date}}',
  changeHistory: 'Change History',
  availability: 'Availability',
  requestNonAvailability: 'Request Availability',
  requestNonAvailabilityExplanationMessage:
    'You are currently available to be scheduled at all times. You can submit a request to your manager to change your availability. Tap on times when you cannot work and then submit your request.',
  requestNonAvailabilityPendingMessage: 'Request awaiting manager’s approval.',
  requestNonAvailabilityApprovedMessage:
    'You are available to be scheduled during the times shown in white. You can submit a request to your manager to change your availability. Tap on a square to change or change back, from available (white) to gray (unavailable) and then submit your request.',
  availabilityChangeRequest: 'Availability Change Request',
  seeRequest: 'See Request',
  availabilityDetails: 'Availability Details',
  noAvailabilities: 'No Availabilities',
  addAvailabilityErrorTitle: 'Could not add availability',
  couldNotApproveRejectAvailabilityRequestErrorTitle:
    'Could not approve/reject availability request',
  enterDescription: 'Enter Description',
  videoError: 'Unable to play this video',
  expired: 'Expired',
  requiresSign: 'Requires Signature',
  requiresAck: 'Requires Acknowledgement',
  overdue: 'Overdue',
  dueIn: 'Due in',
  signed: 'Signed',
  acknowledged: 'Acknowledged',
  openAndSign: 'Open & Sign',
  openAndAck: 'Open & Acknowledge',
  defaultFileAckStatement:
    'I acknowledge that I have reviewed the provided resource and understand its contents, including any outlined policies, procedures, or expectations.',
  resourceHasNoAckRequests: 'Resource has no Acknowledgement Requests',
  requireSignInstructions:
    'Tap file above to open, then click on the checkbox below and type in your name, then tap on the sign button below to complete.',
  requireAckInstructions:
    'Tap file above to open, then click on the checkbox below, then tap on the acknowledge button below to complete.',
  typeNameHere: 'Type your name here',
  sign: 'Sign',
  acknowledge: 'Acknowledge',
  share: 'Share',
  setDueDate: 'Set Due Date',
  dueDate: 'Due Date',
  receiptConfirmation: 'Receipt Confirmation',
  editStatementForRecipient: 'Edit Statement for Recipient',
  typeAMessage: 'Type a message ...',
  chooseRecipients: 'Choose Recipients',
  errorLoadingDetails: 'Error loading details',
  view: 'View',
  copy: 'Copy',
  move: 'Move',
  resourceAccessDenied: 'Resource is no longer available',
  acknowledgements: 'Acknowledgements',
  webLinks: 'Web Links',
  photosVideos: 'Photos & Videos',
  performanceReports: 'Performance Reports',
  teamInsightsReport: 'Team Insights Report',
  storeInsightsReport: 'Store Insights Report',
  selectYear: 'Select Year',
  unavailable: 'Unavailable',
  year: 'Year',
  noCompanySelected: 'No company selected',
  goldStar: 'Gold Star',
  awarding: 'Awarding',
  award: 'Award',
  transferGoldStars: 'Transfer Gold Stars',
  awardGoldStars: 'Award Gold Stars',
  awardStar: 'Award Star',
  transfer: 'Transfer',
  transferring: 'Transferring',
  transferSuccessful: 'Transfer Successful',
  transferSuccessfulDescription:
    'The recipient has received the Gold Stars, and your balance has been reduced by {{starCount}} gold stars.',
  errorGoldStarAlert: 'Error {{type}} gold stars',
  sendMessageToCompanyGroup: 'Company Newsfeed',
  sendMessageToRecepientsStoreGroups: "Each recipient's Store Group",
  optionalMessage: 'Message (Optional)',
  enterTheNumberOfGoldStarsToTransfer:
    'Enter the number of gold stars to transfer',
  goldStars: 'Gold Stars',
  goldStarsAvailable: 'Gold Stars Available',
  transactionLog: 'Transaction Log',
  insufficientGoldStars: 'Insufficient Gold Stars',
  insufficientGoldStarsDescription:
    'You do not have enough gold stars to proceed. You currently have {{goldStars}} gold stars available.',
  pickMembers: 'Pick Member(s)',
  currentMonthStarAllocation: "Current month's star allocation: {{starCount}}",
  previousMonthStarBalance:
    'Gold stars at the end of last month: {{starCount}}',
  star: {
    one: 'Star',
    other: 'Stars',
  },
  goldStarTransaction: 'Transaction Log',
  noChangesThisMonth: 'No changes this month',
  recipient: {
    one: 'Recipient',
    other: 'Recipients',
  },
  postToGroups: 'Post to Groups',
  dueToday: 'Due Today',
  dueThisWeek: 'Due This Week',
  dueLater: 'Due Later',
  completed: 'Completed',
  fileAcknowledgements: 'File Acknowledgements',
  generateReport: 'Generate Report',
  selectReportType: 'Select Report Type',
  yearToDate: 'Year to Date',
  previousYear: 'Previous Year',
  statement: 'Statement',
  acknowledgedOn: 'Acknowledged On',
  requestedBy: 'Requested By',
  requestedOn: 'Requested On',
  generatingReport: 'Generating Report',
  reportGenerated: 'Report Generated',
  confirmGeneration: 'Confirm Generation',
  proceed: 'Proceed',
  dismiss: 'Dismiss',
  uploadedOn: 'Uploaded On',
  transactionsReport: 'Transactions Report',
  generateReportText:
    'Requested data will be sent via direct message from our backend and may take a few minutes to process. Proceed?',
  reportIsBeingGenerated:
    'Your report is being generated and will be sent via direct message.',
  reportGeneratedText:
    'Your report has been generated. Please check your direct messages to view it.',
  alreadySent: 'Already sent',
  reply: 'Reply',
  unreadMessageCount: {
    one: '1 unread message',
    other: '{{count}} unread messages',
  },
  characterLimitExceeded: 'Message Too Long',
  yourMessageExceedsTheCharacterLimit:
    'Your message exceeds the {{limit}} character limit. Please shorten it or split it into multiple messages.',
  addedByNext: 'Added by NEXT',
  newMessagesCount: {
    one: '1 new message',
    other: '{{count}} new messages',
  },
  urgentToggleText: 'Urgent message. Notify all recipients by text message.',
  urgentMessage: 'Urgent Message',
  urgentMessageConfirmationDescription:
    'Are you sure you want to notify all recipients by text message?',
  addTask: 'Add Task',
  editTask: 'Edit Task',
  assignedTo: 'Assigned To',
  photoRequired: 'Photo Required',
  recurring: 'Recurring',
  until: 'Until',
  frequency: 'Frequency',
  interval: 'Interval',
  monthlyOn: 'Monthly On',
  onDay: 'On Day',
  byDay: 'By Day',
  tasks: 'Tasks',
  tasksCount: {
    one: '1 task',
    other: '{{count}} tasks',
  },
  taskDetails: 'Task Details',
  createTask: 'Create Task',
  addRecurrentTask: 'Add Recurrent Task',
  editRecurrentTask: 'Edit Recurrent Task',
  // Repeat text translations
  repeating: 'Repeating',
  every: 'every',
  repeatDay: {
    one: 'day',
    other: 'days',
  },
  repeatWeek: {
    one: 'week',
    other: 'weeks',
  },
  repeatMonth: {
    one: 'month',
    other: 'months',
  },
  repeatYear: {
    one: 'year',
    other: 'years',
  },
  repeatDayNames: {
    MO: 'Mon',
    TU: 'Tue',
    WE: 'Wed',
    TH: 'Thu',
    FR: 'Fri',
    SA: 'Sat',
    SU: 'Sun',
  },
  repeatOn: 'on',
  repeatOnDay: 'on day',
  repeatUntil: 'until',
  taskPhotos: 'Task Photos',
  confirm: 'Confirm',
  due: 'Due',
  open: 'Open',
  late: 'Late',
  noTasks: 'No Tasks',
  freqDays: 'Days',
  month: 'Month',
  freqWeeks: 'Weeks',
  freqMonths: 'Months',
  freqYears: 'Years',
  taskSummaryPlaceholder: 'Enter title of the task',
  taskDescriptionPlaceholder: 'Enter description of the task',
  assignTo: 'Assign To',
  notAssigned: 'Not Assigned',
  repeat: 'Repeat',
  never: 'Never',
  addTaskErrorTitle: 'Could not create task',
  editTaskErrorTitle: 'Could not edit task',
  status: 'Status',
  dueOn: 'Due On',
  photosRequiredLabel: 'Photos (Required)',
  reassign: 'Reassign',
  assign: 'Assign',
  markAsDone: 'Mark as Done',
  deletingRecurringTaskTitle: 'Deleting Repeated Task',
  deletingRecurringTaskDescription:
    'Please select which repeated tasks to delete',
  deleteTaskTitle: 'Delete Task',
  deleteTaskDescription: 'Are you sure you want to delete this task?',
  errorDeletingTask: 'Error deleting task',
  errorMarkingTaskComplete: 'Error marking task complete',
  reassignTask: 'Reassign Task',
  assignTask: 'Assign Task',
  errorReassigningTask: 'Error reassigning task',
  noUsersReassignTaskNote: 'No users available for task reassignment.',
  noUsersAssignTaskNote: 'No users available for task assignment.',
  this: 'This',
  thisAndFollowing: 'This and Following',
  setUpdateType: 'Set Update Type',
  empty: 'Empty',
  selectCompany: 'Select Company',
  selectCompanyDescription: `Select the company whose members you'd like to include in this group`,
  myEarnings: 'My Earnings',
  dailyPayHomeScreenTitle: 'Get your earnings after every shift',
  dailyPayHomeScreenBadge: 'New!',
  dailyPayHomeScreenDescription:
    'Enjoy the flexibility of accessing your earnings in real time. Get started in the DailyPay app today.',
  allAdmins: 'All Admins',
  allObservers: 'All Observers',
  allManagers: 'All Managers',
  allSeniorManagers: 'All Senior Managers',
  allCrew: 'All Crew',
  newHires: 'New Hires',
  allStaff: 'All Staff',
  allGuests: 'All Guests',
  memberAlias: {
    seniorManagers: 'Senior Managers',
    managers: 'Managers',
    staff: 'Staff',
    guests: 'Guests',
    newHires: 'New Hires',
    crew: 'Crew',
    admins: 'Admins',
  },
  removeAliasConfirmationTitle: 'Remove {{alias}} alias',
  removeAliasConfirmationDescription:
    'Are you sure you want to remove {{alias}} alias from this group?',
  activeAliases: 'Active Aliases',
  otherMembers: 'Other Members',
  invalidUrl: 'This URL cannot be opened in the app.',
  webOnboardingNotSupported:
    'New users must complete onboarding in the mobile app.',
}
